import HexConverter from './HexConverter';
import JsonFormatter from './JsonFormatter';
import Base64Encoder from './Base64Encoder';
import UrlEncoder from './UrlEncoder';
import ColorPicker from './ColorPicker';
import TextCaseConverter from './TextCaseConverter';
import UpiQrGenerator from './UpiQrGenerator';

const toolComponents = {
  HexConverter,
  JsonFormatter,
  Base64Encoder,
  UrlEncoder,
  ColorPicker,
  TextCaseConverter,
  UpiQrGenerator,
};

export default toolComponents;
